import Cookies from 'js-cookie';
import { toast } from "react-toastify";
import axiosInstance from "./axios-order";
import { TOKEN_EXPIRE_TIME, TG_TOKEN, WEBSITE_URL } from "./variables";
import { store } from "@/redux/store";
import { setLoadingStatus } from "@/redux/sclices/loading-status-slice";


export const fetchData = async (
    mainUrl,
    url = isRequired("url"),
    type = isRequired("type"),
    dataParams = {},
    token = false,
    props = {},
    loaderShown = true,
    showErrorToast = true
) => {
    props.isHeaderJson = props.isHeaderJson ? props.isHeaderJson : false;
    props.isLoader = props.isLoader ? props.isLoader : true;
    props.uploadProgress = props.uploadProgress ? props.uploadProgress : () => {};
    props.existFile = !!props.existFile;
    props.reFetchCallback = props.reFetchCallback ? props.reFetchCallback : null;
    props.inputParams = props.inputParams ? props.inputParams : [];

    // Check if internet connection available
    if (typeof window !== 'undefined' && !navigator.onLine) {
        toast.warn("Check Your Internet Connection");

        const reRequest = () => {
            if (props.reFetchCallback) {
                props.reFetchCallback();
            }
            window.removeEventListener('online', reRequest);
        }

        window.addEventListener('online', reRequest);

        return {error: true};
    }

    // Base header setting up
    let header = props.isHeaderJson ? {"Content-Type": "application/json; charset=utf-8", 'Origin': WEBSITE_URL} : {'Origin': WEBSITE_URL};

    // Handel setting the content type in header
    if (props.existFile) {
        header = {"Content-Type": "multipart/form-data; boundary", 'Origin': WEBSITE_URL}
    }

    // Handel adding token to header
    if (token) {
        header = {
            headers: Cookies.get(TG_TOKEN) ? {
                    ...header,
                    Authorization: `Bearer ${Cookies.get(TG_TOKEN) ? Cookies.get(TG_TOKEN) : token}`
                } : {
                    ...header,
                }
        };
        if (Cookies.get(TG_TOKEN)) {
            const previousToken = Cookies.get(TG_TOKEN);
            Cookies.set(TG_TOKEN, previousToken, {
                expires: TOKEN_EXPIRE_TIME,
            });
        }
    }
    else {
        header = {
            headers: {
                ...header,
            }
        };
    }

    // Handel requests sent by type
    if (type === 'post') {
        let formData;
        if (props.isHeaderJson) {
            formData = dataParams;
        } else if (props.existFile) {
            formData = new FormData();

            const isFile = input => 'File' in window && input instanceof File;

            for (let key in dataParams) {

                // Array isn't tested
                if ((typeof dataParams[key] === 'object' || Array.isArray(dataParams[key])) && !isFile(dataParams[key])) {
                    for (let i in dataParams[key]) {

                        if (typeof dataParams[key][i] === 'object') {
                            for (let i2 in dataParams[key][i]) {
                                formData.append(`${key}[${i}][${i2}]`, dataParams[key][i][i2])
                            }
                        } else {
                            formData.append(`${key}[${i}]`, dataParams[key][i])
                        }
                    }
                } else {
                    formData.append(key, dataParams[key]);
                }
            }

        } else {
            formData = new URLSearchParams();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        }
        try {
            const {data, status} = token ? await axiosInstance.post(mainUrl + url, formData, {
                ...header,
                onUploadProgress: props.uploadProgress
            }) : await axiosInstance.post(mainUrl + url, formData);

            if (props.isLoader) {
                loader(false);
            }

            return errorHandler(data, status, props.reFetchCallback, 'try', props.inputParams, showErrorToast)

        } catch (e) {
            if (props.isLoader) {
                loader(false);
            }
            return errorHandler(e, null, props.reFetchCallback, 'catch', props.inputParams, showErrorToast)
        }

    }
    else if (type === 'put') {
        let formData;
        if (props.isHeaderJson) {
            formData = dataParams;
        } else if (props.existFile) {
            formData = new FormData();

            const isFile = input => 'File' in window && input instanceof File;

            for (let key in dataParams) {

                //Array isn't tested
                if ((typeof dataParams[key] === 'object' || Array.isArray(dataParams[key])) && !isFile(dataParams[key])) {
                    for (let i in dataParams[key]) {

                        if (typeof dataParams[key][i] === 'object') {
                            for (let i2 in dataParams[key][i]) {
                                formData.append(`${key}[${i}][${i2}]`, dataParams[key][i][i2])
                            }
                        } else {
                            formData.append(`${key}[${i}]`, dataParams[key][i])
                        }
                    }
                } else {
                    formData.append(key, dataParams[key]);
                }
            }

        } else {
            formData = new URLSearchParams();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        }
        try {
            const {data, status} = token ? await axiosInstance.put(mainUrl + url, formData, {
                ...header,
                onUploadProgress: props.uploadProgress
            }) : await axiosInstance.put(mainUrl + url, formData);

            if (props.isLoader) {
                loader(false);
            }

            return errorHandler(data, status, props.reFetchCallback, 'try', props.inputParams, showErrorToast)

        } catch (e) {
            if (props.isLoader) {
                loader(false);
            }
            return errorHandler(e, null, props.reFetchCallback, 'catch', props.inputParams, showErrorToast)
        }

    }
    else if (type === 'patch') {
        let formData;
        if (props.isHeaderJson) {
            formData = dataParams;
        } else if (props.existFile) {
            formData = new FormData();

            const isFile = input => 'File' in window && input instanceof File;

            for (let key in dataParams) {

                //Array isn't tested
                if ((typeof dataParams[key] === 'object' || Array.isArray(dataParams[key])) && !isFile(dataParams[key])) {
                    for (let i in dataParams[key]) {

                        if (typeof dataParams[key][i] === 'object') {
                            for (let i2 in dataParams[key][i]) {
                                formData.append(`${key}[${i}][${i2}]`, dataParams[key][i][i2])
                            }
                        } else {
                            formData.append(`${key}[${i}]`, dataParams[key][i])
                        }
                    }
                } else {
                    formData.append(key, dataParams[key]);
                }
            }

        } else {
            formData = new URLSearchParams();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        }
        try {
            const {data, status} = token ? await axiosInstance.patch(mainUrl + url, formData, {
                ...header,
                onUploadProgress: props.uploadProgress
            }) : await axiosInstance.put(mainUrl + url, formData);

            if (props.isLoader) {
                loader(false);
            }

            return errorHandler(data, status, props.reFetchCallback, 'try', props.inputParams, showErrorToast)

        } catch (e) {
            if (props.isLoader) {
                loader(false);
            }
            return errorHandler(e, null, props.reFetchCallback, 'catch', props.inputParams, showErrorToast)
        }

    }
    else if (type === 'delete') {
        let formData = "?";
        for (let key in dataParams) {
            formData += formData.slice(-1) === "?" ? `${key}=${dataParams[key]}` : `&${key}=${dataParams[key]}`;
        }

        try {
            const {
                data,
                status
            } = token ? await axiosInstance.delete(mainUrl + url + formData, header) : await axiosInstance.delete(mainUrl + url + formData);
            if (props.isLoader) {
                loader(false);
            }

            return errorHandler(data, status, props.reFetchCallback, 'try', props.inputParams, showErrorToast)

        } catch (e) {
            if (props.isLoader) {
                loader(false);
            }
            return errorHandler(e, null, props.reFetchCallback, 'catch', props.inputParams, showErrorToast)
        }
    }
    else {
        let formData = "?";
        for (let key in dataParams) {
            formData += formData.slice(-1) === "?" ? `${key}=${dataParams[key]}` : `&${key}=${dataParams[key]}`;
        }

        try {
            const {
                data,
                status
            } = token ? await axiosInstance.get(mainUrl + url + formData, header) : await axiosInstance.get(mainUrl + url + formData);
            if (props.isLoader) {
                loader(false);
            }

            return errorHandler(data, status, props.reFetchCallback, 'try', props.inputParams, showErrorToast)

        } catch (e) {
            if (props.isLoader) {
                loader(false);
            }
            return errorHandler(e, null, props.reFetchCallback, 'catch', props.inputParams, showErrorToast)
        }
    }
};

const errorHandler = (data, status, reFetchCallback, type, inputParams = [], showErrorToast) => {
    if (type === 'catch') {
        if (data.response) {
            if (data.response.status >= 400 && data.response.status <= 499) {
                if (data?.response?.data?.error_messages) {
                    // Errors are array and handled as array
                    return errorMessageHandler(data.response.data.error_messages, reFetchCallback, data.response.status, inputParams, showErrorToast)
                } else if (data?.response?.data?.detail) {
                    return errorMessageHandler([{key: '', message: data?.response?.data?.detail}], reFetchCallback, data.response.status, inputParams, showErrorToast)
                }
                else {
                    return errorMessageHandler("An unexpected error occurred", reFetchCallback, data.response.status, inputParams, showErrorToast)
                }
            }
            else {
                return errorMessageHandler("An unexpected error occurred", reFetchCallback, data.response.status, inputParams, showErrorToast);
            }

        }
        else {
            return errorMessageHandler('An unexpected error occurred', reFetchCallback, null, inputParams, showErrorToast)
        }
    }
    else {
        //try
        if (data.status >= 400 && data.status <= 499) {
            if (data?.data.error_messages) {
                // errors are array and handled as array
                return errorMessageHandler(data.error_messages, reFetchCallback, data.status, inputParams, showErrorToast)
            } else if (data?.data?.details) {
                return errorMessageHandler([{key: '', message: data.details}], reFetchCallback, data.status, inputParams, showErrorToast)
            } else {
                return errorMessageHandler("An unexpected error occurred", reFetchCallback, data.status, inputParams, showErrorToast)
            }
        } else if (status === 200 || 201 || 204) {
            return data;
        } else {
            return errorMessageHandler("An unexpected error occurred", reFetchCallback, data.status, inputParams, showErrorToast);
        }
    }
}

const errorMessageHandler = async (message, reFetchCallback, code = null, inputParams = [], showErrorToast) => {
    if (typeof window !== 'undefined') {
        if (code === 401) {
            Cookies.remove(TG_TOKEN);
            // if (window && typeof window !== "undefined") {
            //     await window.location.replace('/login');
            // }
        }

        //reFetchCallback just called on the client side request
        if (reFetchCallback) {
            try {
                const reFetchContainer = document.getElementById('re-fetch-container');
                reFetchContainer.classList.remove('d-none');
                reFetchContainer.classList.add('d-flex');
                document.getElementById('re-fetch-btn').onclick = () => {
                    reFetchCallback()
                }
                return {error: true}
            } catch (e) {
                return {error: true};
            }
        }

        if (Array.isArray(message)) {
            let isErrorForInput = false;
            for (let key in inputParams) {
                if (message.find(item => item.param === inputParams[key])) {
                    isErrorForInput = true;
                    break;
                }
            }

            if (isErrorForInput) {
                return {error: true, messages: message};
            } else {
                // for alert
                for (let key in message) {
                    // console.log(message)
                    // console.log(message[key].msg)
                }
            }

        }
        else {
            // console.log(message);
        }

        errorsAlertAndSpecifyHandler(message, code, showErrorToast);
        return {error: true, message};
    }
    else {
        let errors = [];
        if (Array.isArray(message)) {
            for (let key in message) {
                errors.push(message[key].message ? message[key].message : message[key])
            }
        } else {
            errors = [message];
        }
        return {error: {messages: errors, code, showReFetch: !!reFetchCallback}};
    }
}

export const loader = (status = false) => {
    // store.dispatch(setLoadingStatus(status))
};

export const inspectObjects = (obj, toValue = '') => {
    for (let key in obj) {
        if (!obj[key]) {
            obj[key] = toValue;
        }
    }

    return obj;
}

export const editItems = (lastItems, newItem, uniqueFiledNameToCheck = 'id') => {
    return lastItems?.map(item => {
        if (item?.[uniqueFiledNameToCheck] === newItem?.[uniqueFiledNameToCheck]) {
            return newItem
        } else {
            return item
        }
    });
};

export const isEmpty = (obj) => {

    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }

    return JSON.stringify(obj) === JSON.stringify({});
};

export const isRequired = param => {
    throw new Error(`${param} is required`);
};

export const getRand = () => {
    return new Date().getTime().toString() + Math.floor(Math.random() * 100);
};

export const getPriceFormat = (price) => {
    if (!price) return '0';
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const isJson = (str) => {
    if (str === "false" || str === "true") return false;
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const getMultiDigits = (number, gap = 2) => {
    return ("0" + number).slice(-gap);
};

export const arrayToObj = (array, key, getValueKey) => {
    const obj = {};

    for (let k in array) {
        obj[array[k][key]] = array[k][getValueKey];
    }

    return obj;
}

export const isTouchableDevice = () => {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export const changeInputToInvalid = (errorIds = [], prefix = '') => {

    for (let key in errorIds) {
        try {
            document.getElementById(prefix + errorIds[key]).classList.add('invalid-input');
        } catch (e) {

        }
    }

}

export const removeInvalidClass = (id) => {
    try {
        const element = document.getElementById(id);
        if (element.classList.contains('invalid-input')) {
            element.classList.remove('invalid-input');
        }
    } catch (e) {

    }
}

export const generateSearchQuery = (obj) => {
    let searchQuery = '?';

    for (let key in obj) {
        if (obj[key]) {
            searchQuery += `${key}=${obj[key]}&`;
        }
    }

    return searchQuery.slice(0, -1);
}

export const errorsAlertAndSpecifyHandler = (messages, code = 500, showErrorToast) => {
    if (showErrorToast) {
        if (typeof messages === 'object') {
            messages?.forEach((message, index) => {
                toast.error(`${message?.key}: ${typeof message?.message === 'string' ? message?.message : message?.message[0]}`,);
            })
        } else {
            toast.error(`${messages} | ${!!code && code !== 502 ? `Error with code: ${code}` : 'The service may be down, notify the technical team to check it.'}`,);
        }
    }
}

export const copyText = (text, message) => {
    try {
        const input = document.createElement('input');
        input.setAttribute('id', 'copy-text-input');
        document.body.append(input);

        input.value = text;

        const copyText = input;

        // Select the text field
        copyText.select();
        copyText.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText.value);

        document.getElementById('copy-text-input').remove();

        toast.success(message);
    } catch (e) {

    }
}

export const changeHandler = (name, value, setForm, form) => {
    if (form && setForm && name) {
        setForm({
            ...form,
            [name]: value,
        })
    }
}

export const findOptionByValue = (value, array) => {
    return array?.find(option => option.value === value);
}
